/// <amd-module name="Agile/Directory/Redux/Favorites/FavoriteActions" />
import { IFavoriteData } from "Agile/Directory/DirectoryContracts";
import { ActionsUnion, createAction } from "redux/Utils/ActionHelper";

export const enum FavoriteActionTypes {
    ToggleFavorite = "Directory/ToggleFavorite",
    BeginAddFavorite = "Directory/BeginAddFavorite",
    AddFavoriteSuccessful = "Directory/AddFavoriteSuccessful",
    AddFavoriteFailed = "Directory/AddFavoriteFailed",
    BeginRemoveFavorite = "Directory/BeginRemoveFavorite",
    RemoveFavoriteSuccessful = "Directory/RemoveFavoriteSuccessful",
    RemoveFavoriteFailed = "Directory/RemoveFavoriteFailed"
}

export const FavoriteActions = {
    toggleFavorite: (artifactId: string, artifactName: string, favoriteType: string, favoriteId?: string) =>
        createAction(FavoriteActionTypes.ToggleFavorite, {
            artifactId,
            artifactName,
            favoriteType,
            favoriteId
        }),
    beginAddFavorite: (artifactId: string) => createAction(FavoriteActionTypes.BeginAddFavorite, artifactId),
    addFavoriteSuccessful: (favorite: IFavoriteData) => createAction(FavoriteActionTypes.AddFavoriteSuccessful, favorite),
    addFavoriteFailed: (artifactId: string, error: Error) =>
        createAction(FavoriteActionTypes.AddFavoriteFailed, {
            artifactId,
            error
        }),
    beginRemoveFavorite: (artifactId: string) => createAction(FavoriteActionTypes.BeginRemoveFavorite, artifactId),
    removeFavoriteSuccessful: (artifactId: string) => createAction(FavoriteActionTypes.RemoveFavoriteSuccessful, artifactId),
    removeFavoriteFailed: (artifactId: string, error: Error) =>
        createAction(FavoriteActionTypes.RemoveFavoriteFailed, {
            artifactId,
            error
        })
};

export type FavoriteActions = ActionsUnion<typeof FavoriteActions>;
